import { authenticateUserFailure, authenticateUserRequest, authenticateUserSuccess, confirmForgotPasswordRequest, confirmForgotPasswordRequestFailure, confirmForgotPasswordRequestSuccess, forgetPasswordEmailRequest, forgetPasswordEmailRequestFailure, forgetPasswordEmailRequestSuccess, refreshTokenRequest, refreshTokenRequestFailure, refreshTokenRequestSuccess, resetPasswordRequest, resetPasswordRequestFailure, resetPasswordRequestSuccess, tempPasswordRequest, tempPasswordRequestFailure, tempPasswordRequestSuccess } from '../actions/loginServiceAction';
import { call, takeLatest, put, } from 'redux-saga/effects';
import { authenticateUserServiceAPI, confirmForgotPasswordServiceAPI, forgotPasswordEmailServiceAPI, refreshTokenServiceAPI, resetPasswordServiceAPI, tempPasswordServiceAPI } from '../../api/merchantAPI';

export function* authenticateUserServiceCall(action) {
   try {
      const response = yield call(authenticateUserServiceAPI, action);
      if (response?.status === 200) {
         yield put(authenticateUserSuccess(response.data));
      } else {
         response?.code === 'ECONNABORTED' ? yield put(authenticateUserFailure(response)) : yield put(authenticateUserFailure(response.response));
      }
   } catch (e) {
      yield put(authenticateUserFailure(e.message));

   }
}

export function* refreshTokenServiceCall(action) {
   try {
      const response = yield call(refreshTokenServiceAPI, action);
      if (response?.status === 200) {
         yield put(refreshTokenRequestSuccess(response.data));
      } else {
         response?.code === 'ECONNABORTED' ? yield put(refreshTokenRequestFailure(response)) : yield put(refreshTokenRequestFailure(response?.response));
      }
   } catch (e) {
      yield put(refreshTokenRequestFailure(e.message));

   }
}

export function* resetPasswordServiceCall(action) {
   try {
      const response = yield call(resetPasswordServiceAPI, action);
      if (response?.status === 200) {
         yield put(resetPasswordRequestSuccess(response.data));
      } else {
         yield put(resetPasswordRequestFailure('MSG'));
      }
   } catch (e) {
      yield put(resetPasswordRequestFailure(e.message));
   }
}

export function* tempPasswordServiceCall(action) {
   try {
      const response = yield call(tempPasswordServiceAPI, action);
      if (response?.status === 200) {
         yield put(tempPasswordRequestSuccess(response));
      } else {
         yield put(tempPasswordRequestFailure('MSG'));
      }
   } catch (e) {
      yield put(tempPasswordRequestFailure(e.message));
   }
}

export function* forgotPasswordEmailServiceCall(action) {
   try {
      const response = yield call(forgotPasswordEmailServiceAPI, action);
      yield put(forgetPasswordEmailRequestSuccess(response));
   } catch (e) {
      yield put(forgetPasswordEmailRequestFailure(e.message));

   }
}

export function* confirmForgotPasswordServiceCall(action) {
   try {
      const response = yield call(confirmForgotPasswordServiceAPI, action);
      yield put(confirmForgotPasswordRequestSuccess(response));
   } catch (e) {
      yield put(confirmForgotPasswordRequestFailure(e.message));

   }
}

function* loginServiceSaga() {
   yield takeLatest(authenticateUserRequest, authenticateUserServiceCall);
   yield takeLatest(refreshTokenRequest, refreshTokenServiceCall);
   yield takeLatest(resetPasswordRequest, resetPasswordServiceCall);
   yield takeLatest(tempPasswordRequest, tempPasswordServiceCall);
   yield takeLatest(forgetPasswordEmailRequest, forgotPasswordEmailServiceCall);
   yield takeLatest(confirmForgotPasswordRequest, confirmForgotPasswordServiceCall);
}

export default loginServiceSaga;
